import { useSetDefaultSignupForm } from 'modules/auth/hooks/useSetDefaultSignupForm'
import { SignupFormData } from 'modules/auth/hooks/useSignupForm'
import { useSignupFormSubmitHandlers } from 'modules/auth/hooks/useSignupFormSubmitHandlers'
import { EnumAuthTrackingEvents } from 'modules/auth/lib/tracking/events'
import { useAuthenticatedUserQuery } from 'modules/auth/queries/useAuthenticatedUserQuery'
import { useSignupStoreStep } from 'modules/auth/store/useSignupStore'
import { EnumSignupSteps } from 'modules/auth/types/signup'
import { ButtonSkeleton } from 'modules/common/components/_ui/Skeletons/ButtonSkeleton/ButtonSkeleton'
import { HeadingSkeleton } from 'modules/common/components/_ui/Skeletons/HeadingSkeleton/HeadingSkeleton'
import { TextFieldSkeleton } from 'modules/common/components/_ui/Skeletons/TextFieldSkeleton/TextFieldSkeleton'
import { useTrackOnMount } from 'modules/common/hooks/useTrackOnMount'
import { useFormContext } from 'react-hook-form'
import { SignupFormEmail } from './SignupFormEmail'
import { SignupFormEmailConfirm } from './SignupFormEmailConfirm'
import { SignupFormHeader } from './SignupFormHeader'
import { SignupFormName } from './SignupFormName'
import { SignupFormPassword } from './SignupFormPassword/SignupFormPassword'

export const SignupFormContainer = () => {
  useTrackOnMount({
    eventType: EnumAuthTrackingEvents.SIGNUP_WEB_FUNNEL_STARTED,
  })

  const currentStep = useSignupStoreStep()
  const { data: authenticatedUser } = useAuthenticatedUserQuery()

  const { handleSubmit } = useFormContext<SignupFormData>()

  const { isFormReady } = useSetDefaultSignupForm()

  const { onFormValid, onFormInvalid } = useSignupFormSubmitHandlers({
    authenticatedUser,
  })

  return (
    <div
      className="mt-10 flex flex-1 flex-col rounded-t-3xl bg-white px-4 pt-8 md:mt-0 md:px-12 lg:px-24"
      data-testid="signup-form-container"
    >
      <SignupFormHeader authenticatedUser={authenticatedUser} />
      <form
        className="flex flex-1 flex-col pb-20 pt-10 md:justify-center md:pt-5"
        onSubmit={handleSubmit(onFormValid, onFormInvalid)}
        method="post"
      >
        {!isFormReady ? (
          <div className="flex flex-col space-y-6 lg:w-124">
            <HeadingSkeleton uniqueKey="signup-form-heading-skeleton" />
            <TextFieldSkeleton uniqueKey="signup-form-textfield-skeleton" />
            <ButtonSkeleton uniqueKey="signup-form-button-skeleton" />
          </div>
        ) : (
          <>
            {currentStep === EnumSignupSteps.NAME && (
              <SignupFormName key="signup-form-name" />
            )}
            {currentStep === EnumSignupSteps.EMAIL && (
              <SignupFormEmail key="signup-form-email" />
            )}
            {currentStep === EnumSignupSteps.PASSWORD && (
              <SignupFormPassword key="signup-form-password" />
            )}
            {currentStep === EnumSignupSteps.EMAIL_CONFIRM && (
              <SignupFormEmailConfirm key="signup-form-emailconfirm" />
            )}
          </>
        )}
      </form>
    </div>
  )
}
